import React from 'react';
import CookieConsent from 'react-cookie-consent';

const CookieConsentBanner: React.FC = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accepter"
      cookieName="mgeCookieConsent"
      style={{ 
        background: "rgba(33, 37, 41, 0.9)",
        fontSize: "14px",
        padding: "10px 16px",
        alignItems: "center",
        maxWidth: "420px",
        right: "20px",
        left: "auto",
        bottom: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        backdropFilter: "blur(8px)",
      }}
      buttonStyle={{ 
        background: "#E2B13C", 
        color: "#ffffff", 
        fontSize: "14px",
        padding: "8px 16px",
        borderRadius: "6px",
        fontWeight: "500",
        margin: "0 0 0 10px"
      }}
      declineButtonStyle={{
        background: "transparent",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        color: "#ffffff",
        fontSize: "14px",
        padding: "8px 16px",
        borderRadius: "6px",
        marginRight: "8px"
      }}
      contentStyle={{
        flex: "1",
        margin: "0"
      }}
      expires={150}
      enableDeclineButton
      declineButtonText="Refuser"
      onDecline={() => {
        console.log("Cookies refusés");
      }}
    >
      <div className="flex flex-col space-y-2">
        <span className="font-semibold text-sm">🍪 Cookies</span>
        <p className="text-xs text-gray-200 leading-tight">
          Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre politique de confidentialité.
        </p>
      </div>
    </CookieConsent>
  );
};

export default CookieConsentBanner;
